// extracted by mini-css-extract-plugin
export default {"wrapperCasinoGridGames":"CasinoGridGames_wrapperCasinoGridGames__kqm4x","notFoundBlock":"CasinoGridGames_notFoundBlock__b1KRq","shareSvg":"CasinoGridGames_shareSvg__OUEG9"};